import { mutator } from 'satcheljs';
import { default as addIdentity } from '../actions/addIdentity';
import getAccountSourceListStore from '../store/accountSourceListStore';

export default mutator(addIdentity, actionMessage => {
    const store = getAccountSourceListStore();
    store.identities.push(actionMessage.identity);
});
